<template>
  <v-app id="app">
    <v-row no-gutters>
        <transition mode="out-in">
          <router-view :key="$route.path"></router-view>
        </transition>
    </v-row>
          <MessageModal />
          <ReleaseNotesPDF />
  </v-app>
</template>

<script>
import MessageModal from './components/templates/MessageModal.vue';

export default {
  name: 'App',
  components: {
    MessageModal,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
<style lang="scss">
.expanding-v-data-table {
  height:100%;
  display: flex;
  flex-direction: column;
}
</style>
